/**
 * Limity narzędzi bez konta (FE-06, decyzja właściciela 2026-10-19).
 *
 * Bez konta każde narzędzie interaktywne ma kilka użyć, potem okno „Załóż darmowe konto”. Zalogowany (Free
 * i Premium) nie ma limitów. Licznik żyje w `localStorage` tej przeglądarki: świadomie łatwy do obejścia, bo konto
 * zakłada się szybciej, niż czyści pamięć strony.
 *
 * ═══ LICZYMY DZIAŁANIE, NIE WEJŚCIE ═══
 * Użycie to wysłanie formularza albo klik w wykres, nigdy samo otwarcie strony. Prerender i roboty (Googlebot
 * renderuje JavaScript, a front robotów nie rozpoznaje) widzą więc tę samą treść co dziś.
 *
 * Gdy pamięć przeglądarki jest niedostępna (tryb prywatny z blokadą, błąd), limit NIE blokuje.
 */

export const LIMITY_BEZ_KONTA = {
  sprawdzOferte: 1,
  asystent: 1,
  historiaCen: 3,
}

const KLUCZ = 'vv:limit-bez-konta'

const odczytaj = () => {
  try {
    const zapis = JSON.parse(window.localStorage.getItem(KLUCZ) || '{}')
    return zapis && typeof zapis === 'object' ? zapis : {}
  } catch {
    return {}
  }
}

export const zuzyte = (narzedzie) => {
  const n = Number(odczytaj()[narzedzie])
  return Number.isFinite(n) && n > 0 ? n : 0
}

export const zostalo = (narzedzie) => Math.max(0, (LIMITY_BEZ_KONTA[narzedzie] ?? 0) - zuzyte(narzedzie))

/** Zapisuje jedno użycie. Zwraca `false`, gdy limit był już wyczerpany (wtedy nic nie zapisuje). */
export const zuzyj = (narzedzie) => {
  if (zostalo(narzedzie) <= 0) return false
  const stan = odczytaj()
  stan[narzedzie] = zuzyte(narzedzie) + 1
  try {
    window.localStorage.setItem(KLUCZ, JSON.stringify(stan))
  } catch {
    // Nie da się zapisać: użycie przechodzi, limit nie blokuje.
  }
  return true
}

/** Tylko dla testów i podglądu na localhost. */
export const wyczyscLimity = () => {
  try {
    window.localStorage.removeItem(KLUCZ)
  } catch {
    // jak wyżej
  }
}
